import React from 'react'
import PropTypes from 'prop-types'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import {ROLE_EMPLOYEE} from '../../../security/state/auth/const'
import SalesOrderList from '../../../sales-order/component/list/SalesOrderList'
import InvoiceListContainer from '../../../invoice/component/list/InvoiceListContainer'
import PaymentList from '../../../payment/component/list/PaymentList'
import {TAB_ACCOUNTING} from '../../state/detail/const'
import ShipmentList from '../../../logistic/component/list/ShipmentListContainer'


const TabAccounting = (props) => {
    const {tab, customer} = props
    if (tab !== TAB_ACCOUNTING) {
        return null
    }
    return (

        <React.Fragment>

            <Authorization requiredRole={ROLE_EMPLOYEE}>

                <SalesOrderList salesOrderList={customer.salesOrderList}/>

                <ShipmentList shipmentList={customer.shipmentList}/>

                <InvoiceListContainer invoiceList={customer.invoiceList}/>

                <PaymentList paymentList={customer.paymentList}/>

            </Authorization>

        </React.Fragment>

    )
}

TabAccounting.propTypes = {
    tab: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
}

export default TabAccounting



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabAccounting.js